var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.125V11.875C11.75 12.2065 11.6183 12.5245 11.3839 12.7589C11.1495 12.9933 10.8315 13.125 10.5 13.125H3.625C3.29348 13.125 2.97554 12.9933 2.74112 12.7589C2.5067 12.5245 2.375 12.2065 2.375 11.875V5C2.375 4.66848 2.5067 4.35054 2.74112 4.11612C2.97554 3.8817 3.29348 3.75 3.625 3.75H7.375",
    stroke: "#55595F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 1.875H13.625V5.625",
    stroke: "#55595F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 8.75L13.625 1.875",
    stroke: "#55595F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/ExternalLink.ac8a3ac33bad3f36d822212d2626bb02.svg";
export { ForwardRef as ReactComponent };